"use client";
import Image from 'next/image';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import useCompany from '@/app/hooks/useCompany';

export default function Footer() {
  const t = useTranslations('Footer');
  const { company } = useCompany();

  return (
    <footer className="relative w-full bg-white overflow-hidden border-t border-gray-100">
      <div className="absolute right-0 bottom-0 h-full w-full max-w-[50%] opacity-85 pointer-events-none z-0 hidden md:block">
        <Image
          src="/images/footer_bg.png"
          alt="Architectural building wireframe layout"
          fill
          sizes="50vw"
          className="object-contain object-right-bottom select-none"
        />
      </div>

      <div className="relative z-10 max-w-8xl mx-auto px-6 sm:px-12 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-6 items-start pb-16">
          <div className="md:col-span-4 space-y-6">
            <div>
              <h4 className="text-base font-semibold text-gray-900 mb-2">
                {t('address')}
              </h4>
              <address className="not-italic text-sm text-gray-500 leading-relaxed space-y-0.5">
                <p>{company?.address_line1}</p>
                <p>{company?.address_line2}</p>
                <p>{company?.address_line3}</p>
              </address>
            </div>
            <div className="text-sm text-gray-600 font-medium">
              <a href={`tel:${company?.phone_numbers[0]}`} className="hover:text-[#c22738] transition-colors !no-underline">
                {company?.phone_numbers[0]}
              </a> <br />
              <a href={`tel:${company?.phone_numbers[1]}`} className="hover:text-[#c22738] transition-colors !no-underline">
                {company?.phone_numbers[1]}
              </a>
            </div>
          </div>
          <div className="md:col-span-4 flex flex-col items-center text-center space-y-4 pt-4 md:pt-0">
            <div className="relative w-36 h-14">
              <Image
                src="/images/gss_logo.png"
                alt="GFenêtre Logo"
                fill
                className="object-contain"
              />
            </div>
            <p className="text-gray-700 text-base md:text-lg font-medium">
              {t('slogan')}
            </p>
          </div>

           <div className="md:col-span-4 text-right space-y-6">
            <div>
              <div className="not-italic text-sm font-semibold leading-relaxed space-y-0.5">
                <a href="/contact-us" className="hover:text-[#c22738] transition-colors !no-underline">
                  {t('contact_us')}
                </a>
                <br />
                <a href="/terms-conditions" className="hover:text-[#c22738] transition-colors !no-underline">
                  {t('terms_use')}
                </a>
                <br />
                <a href="/privacy-policy" className="hover:text-[#c22738] transition-colors !no-underline">
                  {t('privacy_policy')}
                </a>
              </div>
            </div>
          </div>

        </div>
        <div className="relative z-10 flex flex-wrap gap-x-8 gap-y-3 pb-8 text-sm md:text-base font-medium">
              {company?.socials?.map((s: any) => (
                <Link href={s?.link} target="_blank" rel="noreferrer" className="text-[#c22738] hover:opacity-75 transition-opacity !no-underline">
                  {s?.name}
                </Link>
              ))}
        </div>

        <div className="pt-6 border-t border-gray-100 text-xs sm:text-sm text-gray-600 md:flex justify-between">
          <p>&copy; {new Date().getFullYear()} | {t('rights_reserved')} General Swiss Services</p>
          <p>{t('powered_by')} <a href="https://primalt.com" target="_blank" rel="noreferrer" className="text-violet-600 font-semibold hover:opacity-75 transition-opacity">
            Primalt
          </a></p>
        </div>

      </div>
    </footer>
  );
}